import { Configuration, PublicClientApplication } from "@azure/msal-browser";

export const initializeMsalInstance = async () => {
  const authConfig: Configuration = {
    auth: {
      authority: window.config?.reactAppAuthProviderAuthority,
      clientId: window.config?.reactAppAuthProviderClientId ?? "",
      redirectUri: window.config?.reactAppAuthProviderRedirectUrl
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
    },
    system: {
      allowPlatformBroker: false,
      windowHashTimeout: 60000,
      iframeHashTimeout: 60000,
      loadFrameTimeout: 60000,
      nativeBrokerHandshakeTimeout: 60000,
      redirectNavigationTimeout: 60000
    }
  };
  const msalInstance = new PublicClientApplication(authConfig);
  await msalInstance.initialize();
  return msalInstance;
};
